import { AssetInputFormArgsType } from "../type";
import { useCopies } from "../../../../../hooks/useCopies";
import React from "react";
import * as yup from "yup";
import Validation from "../../../../Validation";
import { FormikProps } from "formik";
import FormContainer from "../../../../index";
import AssetWithNameSelectField from "../../../../fields/assetWithNameSelectField";
import FormTextField from "../../../../fields/textField";
import ButtonType from "../../../../../enums/ButtonTypes";
import { FormDebug } from "../../../../debug";
import Button from "shared/components/button";
import { MAX_FILE_NAME_LENGTH } from "shared/utils/constants";
import { removeExtFromFileName } from "../../../../../utils";
import ButtonGroup from "shared/components/button/components/buttonGroup";

export default function AssetInputForm({ uploadSelectedAsset, ...props }: AssetInputFormArgsType) {
  const copies = useCopies();
  const initialValues = React.useMemo(() => {
    return {
      file: props.asset?.url || "",
      name: props.asset?.name || ""
    };
  }, [props.asset]);

  const validationSchema = React.useMemo(() => {
    return yup.object().shape({
      file: Validation.yupImgIsReq({ copies, required: true }),
      name: Validation.textFieldValidation({ copies, required: true, max: MAX_FILE_NAME_LENGTH })
    });
  }, [copies]);

  const submitHandler = React.useCallback(
    values => {
      uploadSelectedAsset?.({ asset: values.file, name: values.name });
    },
    [uploadSelectedAsset]
  );

  const fileSelectCallback = React.useCallback(async (formikProps: FormikProps<typeof initialValues>, file?: File) => {
    const fileNameAfterExtRemove = removeExtFromFileName(file?.name || "");
    await formikProps.setFieldValue("name", fileNameAfterExtRemove, false);
    await formikProps.setFieldTouched("name", true, false);
    const timerId = setTimeout(async () => {
      await formikProps.validateForm();
      clearTimeout(timerId);
    }, 100);
  }, []);

  return (
    <div>
      <FormContainer
        initialValues={initialValues}
        onSubmit={submitHandler}
        validationSchema={validationSchema}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnMount={false}>
        {(formikProps: FormikProps<typeof initialValues>) => {
          return (
            <FormContainer.Form className="form--fullWidth">
              <AssetWithNameSelectField
                name={"file"}
                label={copies.get("select.file")}
                disabled={props.disabled}
                required={true}
                fileSelectCallback={file => fileSelectCallback(formikProps, file)}
                assetConfig={props.assetConfig}
                assetUploadType={props.assetUploadType}
              />
              <FormTextField
                label={copies.get("file.name.label")}
                name={"name"}
                disabled={props.disabled}
                required={true}
              />
              <ButtonGroup inlineFormButtons>
                <Button.Save type={ButtonType.SUBMIT} />
              </ButtonGroup>
              <FormDebug />
            </FormContainer.Form>
          );
        }}
      </FormContainer>
    </div>
  );
}
